module.exports = __webpack_public_path__ + "files/5ca57fd6e2234eed53a1c8381675831f.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-57x57.png
// module id = 1243
// module chunks = 76